<template>
    <div class="app-inner" id="userClue">
         <div class="p-tit-c">
            <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">线索ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入用户ID" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">用户ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入用户ID" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">手机号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入手机号" v-model="search2" clearable> </el-input>
                    </div>
                    </div>
                </div>
                <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">所属企业名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入所属企业名称" v-model="search3" clearable> </el-input>
                    </div>
                    </div>
                <div class="fl-rt flex align-cen">
                    <div class="label">所属企业ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入所属企业ID" v-model="search4" clearable> </el-input>
                    </div>
                    </div>
                </div>
                <div class="businessList-filter-list flex align-cen">
                      <div class="label">线索类型：</div>
                     <el-select
                            v-model="value"
                            clearable
                            placeholder="请选择"
                            @change="dataSuccess"
                        >
                            <el-option
                            v-for="(item,index) in options"
                            :key="index"
                            :label="item"
                            :value="item"
                            >
                            </el-option>
                        </el-select>
                </div>
                   <div class="businessList-filter-list flex align-cen">
        <div class="label">申请时间：</div>
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="dataSuccess"
        >
        </el-date-picker>
      </div>
     <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="dataSuccess">
          搜索
        </div>
        <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
          导出
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
            </div> 
         </div>
           <div class="businessList-container">
            <div class="businessList-container-table">
                <el-table
                ref="multipleTable"
                :data="itemList"
                tooltip-effect="dark"
                style="width: 100%"
                border
                :row-key="getRowKeyOfTarget"
                @selection-change="handleSelectionChange"
                id='mytable'
                :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                >
                 <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
                     <el-table-column prop="id" label="线索ID" align="center" width="150">
                     </el-table-column>
                      <el-table-column prop="accountId" label="用户ID" align="center" width="150">
                     </el-table-column>
                       <el-table-column prop="userName" label="昵称" align="center" width="150">
                     </el-table-column>
                      <el-table-column prop="loginName" label="手机号" align="center" width="150">
                     </el-table-column>
                      <el-table-column  label="所属企业" align="center" width="150">
            <template slot-scope="scope">
               <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openDialog(scope.row)">{{scope.row.businessNum}}条记录/查看记录</el-button>
            </template>
          </el-table-column>
           <el-table-column prop="applyTime" label="申请时间" align="center" width="200">
                 </el-table-column>
            <el-table-column prop="clueType" label="线索类型" align="center" width="200">
            </el-table-column>
             <el-table-column prop="followNum" label="跟进次数" align="center">
            </el-table-column>
             <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
            <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openWater(scope.row)">查看跟进</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="detail(scope.row)">查看详情</el-button>
            </template>
            </el-table-column>
                </el-table>
                 <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
            </div>
           </div>
      <el-dialog
            title="所属企业"
            :visible.sync="centerDialogVisible"
            width="50%"
            :append-to-body="true"
            center>
            <el-table
            :data="buArr"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="id"
            label="企业ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="企业名称"
           align="center"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="是否为企业管理员" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.isAdmin == 0
                  ? "否"
                  : "是"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog
      title="跟进记录"
    :visible.sync="centerDialogVisible1"
    width="50%"
    :append-to-body="true"
    center
      >
        <div class="followList-dialog">
                         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  跟进
            </div>
             <div class="public-tit-list mft" style="cursor: pointer;"
             @click.stop="openAddfollowList"
             >
                <i class="icon-al-plus-circle-fill"></i>
                 添加跟进
             </div>
        </div>
                         <div class="followList">
                <div class="followList-item"
                v-for="(item, index) in followList" :key="index"
                >
                    <div class="remark">{{item.content}}</div>
                    <div class="info flex align-cen">
                        <div class="info-time">{{item.createTime}}</div>
                       <div class="info-username">{{item.createBy}}</div>
                    </div>
                </div>
             </div>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
import {clueTypeList,getClueList,businessAccountDetail,followList,addFo} from "@/api/index/index" //线索类型列表、线索列表、用户详情、跟进列表、添加跟进
export default {
    name:'userClue',
    data() {
        return {
            buArr:[],
            search:'',
            search1:'',
            search2:'',
            search3:'',
            search4:'',
            value:'',
            options:[],
            value1:'',
            multipleSelection: [],
            centerDialogVisible:false,
            centerDialogVisible1:false,
            itemList:[],
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            followList:[],
            accountId:'',
            pageSizes:[10,20,30,40,50,100],
            start_time:'',
            end_time:'',
              pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
        activated(){
        this.gethisInfo()
        },
    created() {
        this.getClueTypeList()
    },
    methods: {
        // 打开添加跟进窗口
        openAddfollowList(){
                   this.$prompt('跟进内容', '添加跟进', {
                customClass:'follow-box',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType:'textarea',
                inputPlaceholder:'必填【1-500】',
                inputPattern: /^\S{1,500}$/,
                inputErrorMessage: '输入不符合规则'
                }).then(({ value }) => {
                this.addFollow(this.accountId,value)
                }).catch(() => {       
                });
        },
          addFollow(id,content){
             // 打开跟进窗口
                addFo({
                accountId:id,
                content:content
              })
            .then(res => {
                if(res.code == 0){
                   this.$message.success('添加成功')
                  this.getFollowList(id)
                   this.gethisInfo()
                }else{
                    this.$message.error(res.msg)
                }
            })
            .catch(err => {
            })
          },
        // 打开跟进窗口
        openWater(data){
            this.getFollowList(data.accountId)
            this.centerDialogVisible1 = true
        },
        getFollowList(id){
          followList({
                id:id
              })
            .then(res => {
                this.accountId = id
                this.followList = res.data
            })
            .catch(err => {
            })
        },
          // 打开企业弹框窗口
        openDialog(data){
                  businessAccountDetail({
                id:data.accountId
              })
            .then(res => {
                this.buArr = res.data.platformBusinessList
            })
            .catch(err => {
            })
            this.centerDialogVisible = true
        },
           // 打开企业管理员详情
        detail(data){
            this.$router.push({
            name: "adminDetail",
            query:{
                id:data.accountId,
                type:3,
                str:'userCure'
            }
           })
        },
        // 重置
        reset(){
             this.search = ""
          this.search1 = ""
          this.search2 = ""
          this.search3 = ""
          this.search4 = ""
           this.value = ""
           this.value1 = ""
           this.currentPage = 1
         this.gethisInfo()
        },
        // 导出
        exportExcel(val){
                if(val.length !=0){
        let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '线索ID':val[item].id, 
              '用户ID':val[item].accountId, 
              '昵称':val[item].userName, 
              '所属企业':val[item].businessNum + '家',
              '申请时间':val[item].applyTime,
              '线索类型':val[item].clueType,
              '跟进次数':val[item].followNum,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
             }else{
                this.$message.error('未选择导出数据')
             }
        },
        // 搜索
        dataSuccess(){
             if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            this.currentPage = 1
             this.gethisInfo()
        },
        // 获取线索类型列表
        getClueTypeList(){
               clueTypeList({})
            .then(res => {
                this.options = res.data
            })
            .catch(err => {
            })
        },
        // 获取线索列表
        gethisInfo(){
            let params = {
                 id:this.search,
                 accountId:this.search1,
                 loginName:this.search2,
                 businessName:this.search3,
                 businessId:this.search4,
                 clueType:this.value,
                 applyTimeStart:!this.value1 ? '' : this.start_time,
                 applyTimeEnd:!this.value1 ? '' : this.end_time,
                 current: this.currentPage,
                 size:this.PageSize,
            }
              getClueList(params)
            .then(res => {
              this.itemList = res.data.records

             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
            getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
       handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
    },
}
</script>
<style lang="scss" scoped>
#userClue{
    .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
    .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
}
::v-deep {
     .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
              .followList{
                padding: 10px;
                padding-top: 0;
                height: 400px;
                overflow: hidden;
                overflow-y: auto;
                .followList-item{
                    border-bottom: 1px solid #ddd;
                    padding: 10px 0;
                    .info-username{
                        padding-left: 20px;
                        position: relative;
                    }
                    .info-username::before{
                        content: '';
                        width: 1px;
                        height: 20px;
                        background: #ccc;
                        position: absolute;
                        left: 10px;
                        top: 2px;
                    }
                }
                }

        }


}
</style>